var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_2_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ScnSoft-COM-HomePage-1440_illustrations",
    transform: "translate(-224.000000, -6363.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Industry",
    transform: "translate(135.000000, 6166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(84.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_2_1",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(9.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.622642, 0.400000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4600943,59.934849 L68.6306604,45.4018302 C70.0078302,44.6071132 70.6451887,43.5305094 70.5902831,42.4114528",
    id: "Fill-2",
    fill: "#BFC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5901132,42.4114528 L70.5997359,42.4114528 L70.5997359,37.5503207 L61.5618113,35.2125849 L41.5218113,23.6427736 C38.1487924,21.6950377 33.0453962,21.4827736 30.1235094,23.1706981 L9.59728302,35.0206982 L0.0159622641,37.2899434 L0.0159622641,42.0888113 C0.00916981132,42.1957925 0.0114339623,42.3044717 0.0159622641,42.4114528 L0.0159622641,42.4861698 L0.0199245282,42.4861698 C0.115018868,43.7173019 1.04841509,44.993717 2.79577359,46.0018302 L29.0842641,61.1801321 C32.4589811,63.1278679 37.5618113,63.3401321 40.4836982,61.6533396 L43.4599245,59.934849",
    id: "Fill-4",
    fill: "#BFC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6305472,40.2805472 L40.4837547,56.5320567 C37.561868,58.218283 32.4590377,58.0060189 29.0843208,56.058849 L2.79583019,40.8816792 C-0.578886792,38.9328114 -0.94454717,35.987151 1.97733963,34.2997925 L30.1235661,18.0494151 C33.0454529,16.3620566 38.148283,16.5737547 41.521868,18.5214906 L67.8114905,33.6997925 C71.1867736,35.6469623 71.552434,38.5943207 68.6305472,40.2805472",
    id: "Fill-6",
    fill: "#E9E8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7584718,3.05745283 L21.3946982,0.945 C22.5052641,0.299150943 23.8111132,0.222735849 25.1996037,0.670471698 C26.0209246,0.935377358 26.8009245,1.29254718 27.5390378,1.71933962 C32.8337547,4.77594339 35.9854528,11.370283 36.4903584,12.5634906 L32.8546981,14.6759433 C32.3497925,13.4827358 29.1980943,6.8895283 23.9028114,3.83179245 C23.1646981,3.40556603 22.3846982,3.04783019 21.5639434,2.78405661 C20.1754529,2.33632075 18.8690377,2.41216982 17.7584718,3.05745283",
    id: "Fill-8",
    fill: "#123155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6592641,28.1328114 C53.6992641,20.5043207 49.872849,15.0828114 45.8868113,12.4054528 C45.521717,12.1597924 45.1696415,11.9407358 44.8305849,11.7443208 C41.5447358,9.8475283 39.4520944,10.1690377 38.1564339,10.9218679 L34.5202075,13.0348868 C35.815868,12.2820566 37.9085094,11.9605472 41.1943585,13.8573396 C41.5339811,14.0531887 41.8860566,14.2733773 42.251151,14.5179057 C46.2371887,17.1963962 50.0630377,22.6173397 51.0230377,30.2452641 C51.7407736,35.9446981 49.4171887,39.138849 46.1007735,41.0667736 L49.737,38.9531886 C53.0534151,37.0263963 55.377,33.8316792 54.6592641,28.1328114",
    id: "Fill-10",
    fill: "#123155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5167358,29.9989812 C53.1622075,43.0665283 38.8182453,42.9663397 33.1799433,44.6129434 C27.5659811,36.4704906 13.2735282,20.036717 14.9852264,8.90728302 C15.8280566,3.41615094 18.668434,1.512 21.9752265,2.57841509 C22.7959811,2.84218867 23.5759811,3.19992453 24.3140944,3.62671698 C29.6088114,6.6838868 32.7610755,13.2770943 33.2654151,14.4703018 C33.8116415,13.8148302 35.8974905,10.2680377 41.6880566,13.6110567 C42.0271132,13.8069057 42.3791887,14.0259623 42.7442831,14.2716226 C46.7303207,16.9495471 50.5567359,22.3704905 51.5167358,29.9989812",
    id: "Fill-12",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3594718,12.8376226 L32.8938114,33.6372453 L36.6590943,23.1146038 L38.2236227,31.1432831 L39.4847547,27.6412076 L40.5738113,31.4761132 L41.1964528,30.9417736 L56.4358868,39.4629057 C56.6447547,39.5834718 56.8156981,39.8772453 56.814566,40.1200754 C56.814,40.3578113 56.6419245,40.458 56.4330567,40.3374339 L41.6741887,31.9283774 L40.3423019,33.0661133 L39.5300377,30.2076226 L38.1138114,34.1455472 L36.5504151,26.1247924 L32.7302265,36.7996981 L29.2236227,16.173283 L25.9111698,26.4168679 L24.7666415,22.1664906 L10.4232453,13.9391321 C10.2132453,13.818 10.044,13.5213962 10.0451321,13.2836603 C10.0456981,13.0402642 10.2155094,12.9434718 10.4260755,13.0651698 L25.0332453,21.4447924 L25.854566,23.6693208 L29.3594718,12.8376226 Z",
    id: "Fill-14",
    fill: "#CECDCC"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/Healthcare.d2ddda9bfae69307ecacfd99c785ead1.svg";
export { ForwardRef as ReactComponent };